import React from "react";
import { Msg } from "../../i18n";

export default class RecentProjects extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projects: [
        {
          href: "/",
          title:
            "Online e-merchant management system - attaching integration with the iOS"
        },
        {
          href: "/",
          title: "Notes on pipeline upgradee"
        },
        {
          href: "/",
          title: "Assesment Report for merchant account"
        }
      ]
    };
  }
  clearProjects = () => {
    this.setState({
      projects: []
    });
  };
  render() {
    let projects = this.state.projects;
    return (
      <div className="project-context hidden-xs dropdown">
        
       <b style={{display: "block",marginLeft: "190px" ,color: "#6e3671" ,fontSize:"24px",  fontWeight: "700",  textTransform: "uppercase",  textShadow: "0 0 1px #fff"}}>Spark Base Kitchen Software Solution</b>
      {/*  <marquee style={{ color:"#6e3671" }}
          duration={3000}
          marqueeOnStart
          loop
          marqueeDelay={1000}
    marqueeResetDelay={1000}>Sparktech Systems Pvt Ltd (SSPL) provides Spark Base Kitchen Software Solution for Central Kitchen Monitoring for single or multiple outlets.</marquee> */}
       {/*} <span className="label">
          <Msg phrase="Projects" />
        </span>
        <span
          className="project-selector dropdown-toggle"
          data-toggle="dropdown"
        >
          <Msg phrase="Recent projects" />
          {projects.length ? <i className="fa fa-angle-down" /> : null}
        </span>

        {projects.length ? (
          <ul className="dropdown-menu">
            {projects.map(function(project, idx) {
              return (
                <li key={idx}>
                  <a href={project.href}>{project.title}</a>
                </li>
              );
            })}

            <li className="divider" />
            <li>
              <a href="#/" onClick={this.clearProjects}>
                <i className="fa fa-power-off" /> Clear
              </a>
            </li>
          </ul>
          ) : null}  */}
      </div>
    );
  }
}
